import { falsoDefaultNodeDefs } from "./default";
import { NodeDefinition } from "src/types/node.types";
import * as falsoCustomNodeDefs from "./custom";

const customTypes = Object.values(falsoCustomNodeDefs).map(({ type }) => type);
const defaultNodeDefs = falsoDefaultNodeDefs.filter(
  (def) => !customTypes.includes(def.type)
);

export const falsoNodeDefs = [
  ...Object.values(falsoCustomNodeDefs),
  ...defaultNodeDefs,
];

export function getFalsoNodeDef(type: string): NodeDefinition<any, any> {
  return falsoNodeDefs.find((def) => def.type === type)!;
}
